import IUpdateUsuarioRequest from '../entities/IUpdateUsuarioRequest'
import { IUserRepository } from '../repositories/IUserRepository'

export interface IUpdateUsuario {
  execute(id: number, params: IUpdateUsuarioRequest): Promise<void>
}

export default class UpdateUsuarioImpl implements IUpdateUsuario {
  constructor(private readonly userRepository: IUserRepository) {}

  public async execute(
    id: number,
    params: IUpdateUsuarioRequest,
  ): Promise<void> {
    await this.userRepository.updateUsuario(id, params)
  }
}
